





















































import Vue from "vue";

export default Vue.extend({
  name: "SideNavbar",

  computed: {
    login() {
      return this.$store.state.userModule.status.loggedIn;
    }
  },

  data: () => ({
    links: [
      {
        name: "홈",
        to: "/"
      },
      {
        name: "경매",
        to: "/auction"
      },
    ],
    nickname: ""
  }),
  methods: {
    logout() {
      this.$store.dispatch("userModule/logout");
      this.$router.push({ path: '/' })
    }
  },
  created() {
    if (localStorage.getItem("user")) {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      this.nickname = user.object.user.nickname;
    }
  }
});
